// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

import { ChevronRight } from "lucide-react";

import type { TwoColumnImageCard as TwoColumnImageCardType } from "@repo/ui/types/cms";

export interface TwoColumnImageCardProps {
  item: TwoColumnImageCardType;
}

export default function TwoColumnImageCard({ item }: Readonly<TwoColumnImageCardProps>) {
  const {
    background_image,
    title,
    subtitle,
    col1_heading,
    col1_description,
    col1_cta_text,
    col1_cta_link,
    col2_heading,
    col2_description,
    col2_cta_text,
    col2_cta_link,
  } = item;

  return (
    <div
      className="h-full w-full rounded-lg bg-cover bg-center p-6 text-white"
      style={background_image ? { backgroundImage: `url(${background_image})` } : undefined}
    >
      {(title || subtitle) && (
        <div className="mt-8 space-y-3 text-center">
          {title && <h2 className="text-3xl font-bold">{title}</h2>}
          {subtitle && <p className="text-sm">{subtitle}</p>}
        </div>
      )}

      <div className="relative mt-8 grid grid-cols-1 gap-4 text-center md:grid-cols-2">
        {(col1_heading || col1_description || col1_cta_text) && (
          <div className="px-2">
            {col1_heading && <h3 className="text-base font-semibold">{col1_heading}</h3>}
            {col1_description && (
              <p
                className="mt-2 text-xs opacity-90 [&_p]:m-0"
                dangerouslySetInnerHTML={{ __html: col1_description }}
              />
            )}
            {col1_cta_text && (
              <Link
                href={col1_cta_link || "#"}
                className="mt-3 inline-flex items-center text-sm font-medium no-underline"
              >
                {col1_cta_text}
                <ChevronRight className="ml-1 inline-block" size={16} />
              </Link>
            )}
          </div>
        )}
        <div className="absolute top-1/2 left-1/2 hidden h-3/4 w-px -translate-x-1/2 -translate-y-1/2 bg-white/40 md:block" />

        {(col2_heading || col2_description || col2_cta_text) && (
          <div className="px-2">
            {col2_heading && <h3 className="text-base font-semibold">{col2_heading}</h3>}
            {col2_description && (
              <p
                className="mt-2 text-xs opacity-90 [&_p]:m-0"
                dangerouslySetInnerHTML={{ __html: col2_description }}
              />
            )}
            {col2_cta_text && (
              <Link
                href={col2_cta_link || "#"}
                className="mt-3 inline-flex items-center text-sm font-medium no-underline"
              >
                {col2_cta_text}
                <ChevronRight className="ml-1 inline-block" size={16} />
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
